import { Capacitor } from "@capacitor/core";
import { APP_EDITION } from "./edition.ts";

export type NativePlatform = "android" | "ios";

/** Mağaza uygulamasının platformu; tarayıcıda null. URL bayrakları ve tarayıcı depolaması bunu açamaz. */
export function nativePlatform(): NativePlatform | null {
  if (APP_EDITION !== "tr" || !Capacitor.isNativePlatform()) return null;
  const platform = Capacitor.getPlatform();
  return platform === "android" || platform === "ios" ? platform : null;
}

/** Android ya da iOS mağaza uygulaması: native oturum, reklam ve satın alma açık. */
export function isNativeApp(): boolean {
  return nativePlatform() !== null;
}

export function isTurkishAndroid(): boolean {
  return nativePlatform() === "android";
}

export function isTurkishIos(): boolean {
  return nativePlatform() === "ios";
}

export function apiOrigin(): string {
  return isNativeApp() ? "https://muhtesemkelime.com" : "";
}

/** Başkasına gönderilecek bağlantıların adresi; iOS paketi yerel bir adresten açılıyor. */
export function publicOrigin(): string {
  return apiOrigin() || window.location.origin;
}
